<template>
  <div>
    <el-row :gutter="15" class="wrapper">
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_boss_confirm'] } }">
                <p class="value">{{ data.orders_wait_supplier_boss_confirm_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待员工确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_confirm'] } }">
                <p class="value">{{ data.orders_wait_supplier_confirm_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">员工已确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['confirmed'] } }">
                <p class="value">{{ data.orders_confirmed_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">面料到位订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['fabric_arrived'] } }">
                <p class="value">{{ data.orders_fabric_arrived_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">裁床更新订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['cutting_updated'] } }">
                <p class="value">{{ data.orders_cutting_updated_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">印绣花进行中订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['printing_in_progress'] } }">
                <p class="value">{{ data.orders_printing_in_progress_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">车间进行中订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['workshop_in_progress'] } }">
                <p class="value">{{ data.orders_workshop_in_progress_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">尾部进行中订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['tail_in_progress'] } }">
                <p class="value">{{ data.orders_tail_in_progress_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">部分完成订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['partial'] } }">
                <p class="value">{{ data.orders_partial_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">退厂返工订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'failed' } }">
                <p class="value">{{ data.order_delivery_failed_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待接收辅料订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { order_accessory_deliveries_state_eq: 'submited' } }">
                <p class="value">{{ data.orders_accessory_state_submited_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="section">
      <el-col :span="24" style="padding: 20px;">
        <h3 style="margin-bottom:20px; text-align:center;">订单数据汇总</h3>
        <el-date-picker
          v-model="companyOrderSummaryDateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleCompanyOrderSummaryDateChange"
          style="margin-bottom: 20px;"
          :clearable="false"
          :required="true"
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportCompanyOrderSummary"
          style="margin-bottom: 20px; float: right;"
        >
          导出数据
        </el-button>
        <el-table :data="companyOrderSummary" show-summary :summary-method="getSummaries">
          <el-table-column prop="factory_name" label="加工厂名称" />
          <el-table-column prop="count" label="总款数" />
          <el-table-column prop="on_time_count" label="按时交货数量" />
          <el-table-column prop="in_advance_count" label="提前交货数量" />
          <el-table-column prop="in_advance_rate" label="提前率">
            <template slot-scope="scope">
              {{ ((scope.row.in_advance_count / scope.row.count) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column prop="overdue_count" label="逾期交货数" />
          <el-table-column prop="overdue_rate" label="逾期率">
            <template slot-scope="scope">
              {{ ((scope.row.overdue_count / scope.row.count) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column prop="return_rate" label="退货率">
            <template slot-scope="scope">
              {{ Number(scope.row.return_rate).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column prop="liquidated_damages" label="违约金费用">
            <template slot-scope="scope">
              {{ Number(scope.row.liquidated_damages).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SupplierBossHome extends Vue {
  data = {
    orders_wait_supplier_boss_confirm_count: 0,
    orders_wait_supplier_confirm_count: 0,
    orders_confirmed_count: 0,
    orders_fabric_arrived_count: 0,
    orders_cutting_updated_count: 0,
    orders_printing_in_progress_count: 0,
    orders_workshop_in_progress_count: 0,
    orders_tail_in_progress_count: 0,
    orders_partial_count: 0,
    order_delivery_failed_count: 0,
    orders_accessory_state_submited_count: 0
  };
  companyOrderSummary = [];
  companyOrderSummaryDateRange = [
    new Date(new Date().setDate(1)), // 月初
    new Date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)) // 月末
  ];

  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = '合计';
        return;
      }
      if (column.property === 'in_advance_rate' || column.property === 'overdue_rate') {
        const values = data.map(item => Number(item[column.property === 'in_advance_rate' ? 'in_advance_count' : 'overdue_count']) || 0);
        const totalCount = values.reduce((sum, value) => sum + value, 0);
        const allTotalCount = data.map(item => Number(item['count']) || 0).reduce((sum, value) => sum + value, 0);
        const average = (totalCount / allTotalCount || 0) * 100;
        sums[index] = average.toFixed(2) + '%';
      } else if (column.property === 'return_rate') {
        // 退货率平均计算
        const totalReturnCount = data.map(item => ((item.return_rate || 0) / 100 * item.count)).reduce((sum, value) => sum + value, 0);
        const allTotalCount = data.map(item => Number(item['count']) || 0).reduce((sum, value) => sum + value, 0);
        const average = (totalReturnCount / allTotalCount || 0) * 100;
        sums[index] = average.toFixed(2) + '%';
      } else if (column.property === 'liquidated_damages') {
        // 违约金费用保留2位小数
        const values = data.map(item => Number(item[column.property]) || 0);
        sums[index] = values.reduce((sum, value) => sum + value, 0).toFixed(2);
      } else if (column.property) {
        // 其他计数列显示整数
        const values = data.map(item => Number(item[column.property]) || 0);
        sums[index] = values.reduce((sum, value) => sum + value, 0);
      }
    });
    return sums;
  }

  async exportCompanyOrderSummary() {
    await this.$request.get('/dashboard/export_company_order_summary', {
      start_at: this.companyOrderSummaryDateRange[0],
      end_at: this.companyOrderSummaryDateRange[1]
    })

    this.$message.success('文件正在导出，导出成功后将会发送到邮箱')
  }

  async handleCompanyOrderSummaryDateChange(value) {
    this.companyOrderSummaryDateRange = value
    this.fetchCompanyOrderSummary()
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/supplier_boss_role')
    this.fetchCompanyOrderSummary()
  }

  async fetchCompanyOrderSummary() {
    const data = await this.$request.get('/dashboard/company_order_summary', {
      start_at: this.companyOrderSummaryDateRange[0],
      end_at: this.companyOrderSummaryDateRange[1]
    })
    // API返回对象包含factories数组，直接使用工厂数据
    this.companyOrderSummary = (data && data.factories) || []
  }
}
</script>
